$('#frm_attributionprospects').on('click', '.btn_add_restriction, .btn_remove_restriction', function() {
	$('.btn', $(this).parent()).toggleClass('d-none');
	if( $(this).hasClass('btn_remove_restriction') )
		$($(this).data('container')).html('');
});

// switch administrateur
$('#frm_user_administrateur').on('change', function() {
	if( $(this).prop('checked') ) {
		$('input[name="droits[]"][data-administrateur]').prop('checked', true).prop('disabled', true);
		$('input[name="droits[]"]:not([data-administrateur])').prop('checked', false).prop('disabled', false);
		$('.btn_profil').prop('disabled', true);
		$('#frm_user_invite').prop('checked', false);
		$('#profil_invite_programmes').addClass('d-none');
	}
	else {
		$('input[name="droits[]"][data-administrateur]').prop('disabled', false);
		$('.btn_profil').prop('disabled', false);
		if( $('.btn_profil[data-name="Invité"].active').get().length )
			$('#profil_invite_programmes').removeClass('d-none');
	}
});
$('.btn_profil').on('click', function() {
	var droits = $(this).data('droits');
	$('.btn_profil.active').removeClass('active');
	$(this).addClass('active');
	$('input[name="droits[]"]').each(function(i, el) {
		if( droits.indexOf($(el).attr('value')) != -1 )
			$(el).prop('checked', true);
		else
			$(el).prop('checked', false);
	});
});

// switch invite
$('#frm_user_invite').on('change', function() {
	var droits = $(this).data('droits');
	if( $(this).prop('checked') ) {
		$('#frm_user input[name="droits[]"').each(function(i, el) {
			$(el).prop('checked', droits.indexOf($(el).val()) != -1);
		});
		$('#profil_invite_programmes').removeClass('d-none');
		$('#frm_user_administrateur').prop('checked', false);
	}
	else {
		$('#profil_invite_programmes').addClass('d-none');
	}
});